var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "filters__locations" }, [
    _c(
      "div",
      { staticClass: "filters__locations-wrapper" },
      [
        _c("div", { staticClass: "filters__dropdown-wrapper" }, [
          _c(
            "label",
            {
              staticClass: "utility-flex",
              attrs: { for: "filters__location-dropdown" },
            },
            [_vm._v("Region:")]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              staticClass: "filters__location-dropdown filters__dropdown",
              attrs: {
                name: "Regions",
                id: "Regions",
                selectedRegionID: _vm.selectedRegionID,
              },
              on: { change: _vm.updateSelected },
            },
            [
              _c("option", { attrs: { value: "0" } }, [_vm._v("All regions")]),
              _vm._v(" "),
              _vm._l(_vm.locations, function (location) {
                return _c(
                  "option",
                  { key: location.ID, domProps: { value: location.ID } },
                  [_vm._v(_vm._s(location.Name))]
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("FiltersSubregion", {
          attrs: {
            deleteSubRegions: _vm.deleteSubRegions,
            disableSubRegionDropdown: _vm.disableSubRegionDropdown,
            isTab2: _vm.isTab2,
            selectedSubregions: _vm.selectedSubregions,
            subRegionsForRegion: _vm.subRegionsForRegion,
            updateSubRegions: _vm.updateSubRegions,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }